<template>
  <div class="About">
    <ld-header>关于我们</ld-header>

    <div :class="'comp white text-center' + (compNo == 'BTLH'? ' compBgBtlh': ' compBg')">
      <img
        v-show="loginConfig.logoUrl"
        :src="loginConfig.logoUrl"
        width="54"
      >
      <h3 class="font-lg font18">
        {{ loginConfig.pageName }}
      </h3>
      <div class="font-sm font12">
        v{{ version }}
      </div>
    </div>
    <van-cell
      is-link
      title="推荐给朋友"
      @click="share"
    />
    <van-cell
      v-show="isH5()==false"
      is-link
      :title="`版本更新(${version})`"
      @click="update(true)"
    />
    <van-cell
      is-link
      title="服务协议"
      @click="showLicense=true"
    />
    <van-cell
      is-link
      title="隐私条款"
      @click="showLicense2=true"
    />
    <van-popup
      v-model="showShareImg"
      class="popup-width"
      :close-on-popstate="true"
      style="height:70%"
    >
      <div
        class="custom-imgbox full-width full-height"
        v-lazy:background-image="shareimg"
      >
        <!--        <img v-lazy="loginConfig.qrCode || orCode">-->
      </div>
    </van-popup>

    <!--服务协议-->
    <van-popup
      v-model="showLicense"
      position="right"
      :close-on-popstate="true"
      class="full-height full-width"
    >
      <ld-header @click-left="showLicense = false">
        《{{ loginConfig.pageName }}服务协议》
      </ld-header>
      <div class="font14 showLicense">
        <mescroll-vue
          ref="mescroll"
          :down="{ use: false }"
        >
          <div v-if="loginConfig.by5">
            <pre
              v-html="loginConfig.by5"
              class="pad8 pre-wrap"
            />
          </div>
        </mescroll-vue>
      </div>
    </van-popup>
    <!--隐私条款-->
    <van-popup
      v-model="showLicense2"
      position="right"
      :close-on-popstate="true"
      class="full-height full-width"
    >
      <ld-header @click-left="showLicense2 = false">
        《{{ loginConfig.pageName }}隐私条款》
      </ld-header>
      <div class="font14 showLicense2">
        <mescroll-vue
          ref="mescroll"
          :down="{ use: false }"
        >
          <div v-if="loginConfig.by2">
            <pre
              v-html="loginConfig.by2"
              class="pad8 pre-wrap"
            />
          </div>
        </mescroll-vue>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {  Cell,Lazyload,Popup  } from 'vant'
import ldHeader from 'Common/ldHeader'
import { update } from 'CommonUtils/updateApp.js'
import { appVersion , isH5} from 'CommonUtils/plus.js'
// , shareSystem ,getSysType
import shareimg from 'Assets/images/user/bg_share.png'
import orCode from 'Assets/images/user/orCode.png'
import {localget} from 'Utils/storage'

export default {
  components: {
    ldHeader,
    [Cell.name]: Cell,
    [Lazyload.name]: Lazyload,
    [Popup.name]: Popup,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
  },
  data () {
    return {
      version: '1.0',
      showShareImg:false,
      shareimg,
      orCode,
      showLicense:false,
      showLicense2:false,
      compNo: ''
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'loginConfig'])
  },
  created(){
    this.version=appVersion()
  },
  mounted () {
    let state = localget('VUEX_STATE') || {}
    if (state.app && state.app.loginConfig) {
      this.compNo = state.app.loginConfig.by4
    }
  },
  methods:{
    update,
    appVersion,
    isH5,
    share(){
      // if(getSysType()==10506){
      this.showShareImg=true
      // }else{
      // 	shareSystem({
      // 		type:'text',
      // 		content: '智通天行',
      // 		href: 'https://www.pgyer.com/7016612905'
      // 	})
      // }
    }
  }
}
</script>

<style lang="less" scoped>
.About {
  .comp {

  }

  .compBg {
    padding: 42px 0;
    background: url('~Assets/images/user/bg_about.png') no-repeat;
    background-size: 100%;
  }

  .compBgBtlh {
    padding: 42px 0;
    background: url('~Assets/images/user/bg_about_btlh.png') no-repeat;
    background-size: 100%;
  }

.showLicense {
    height: calc(100vh - 50px);
    padding: 10px;
    text-indent: 20px;
  }
.showLicense2 {
    height: calc(100vh - 50px);
    padding: 10px;
    text-indent: 20px;
  }
}
</style>



